import {Outlet} from "react-router-dom";

export default function Invoice () {
    return (
        <>
            <Outlet/>
        </>
    )
}